<script setup lang="ts">
  onMounted(async () => {})
</script>

<template>
  <div class="min-h-screen">
    <RouterView />
  </div>
</template>
